import Vue from "vue";
import Vuex from "vuex";

import getters from "./getters";
import actions from "./action";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  dialogSignIn: false,
  dialogLogin: false,
  dialogChangePwd: false,
  userInfo: null,
  head_nav: null,
  me_active_nav: null,
  city_name: localStorage.getItem("city_name"),
  cate_id: localStorage.getItem("cate_id"),
  category_name: localStorage.getItem("category_name"),
  token: localStorage.getItem('token') !== null ? localStorage.getItem('token') : ''
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js